/* eslint-disable no-unused-vars */
import axios from '../axios'

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },
  updateCurrentLayout ({ commit }, val) {
    commit('UPDATE_MAIN_LAYOUT_TYPE', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  ////////////////////////////////////////////////
  // Authentication: login, register, rest password
  ///////////////////////////////////////////////

  login ({commit}, credentials) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/login', credentials)
        .then((response) => {
          commit('SET_TOKEN_TO_LOCALSTORAGE', response.data.Authorization)
          commit('SET_TOKEN_TO_HEADER_REQUEST', response.data.Authorization)
          commit('SET_USER_DATA', credentials.email)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  register ({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/client', credentials)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  logout ({commit}) {
    return new Promise((resolve, reject) => {
      axios.post('/auth/logout')
        .then((response) => {
          commit('CLEAR_USER_DATA')
          resolve(response)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.data.error === 'Usuario no autenticado') {
            commit('CLEAR_USER_DATA')
          }
          reject(error)
        })
    })
  },
  
  forgotPassword ({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/auth/forgot-password', credentials)
        .then((response) => {
          commit('FORGOT_PASSWORD')
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  resetPassword ({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/auth/reset-password', credentials)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                      //////////////////////////////////////////////////////
  //////////////////////////////////////   U S U A R I O S  PDN   //////////////////////////////////////////////////////
  ///////////////////////////////////////    E M P L O Y E E S     //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchUserImageCorner ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/user/image-profile')
        .then((response) => {
          commit('SET_USER_IMAGE_CORNER', response.data.thumbnail_profile_image)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUserData ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/auth/user')
        .then((response) => {
          commit('SET_USER_DATA', response.data.data)
          commit('SET_USER_ROLES', response.data.roles)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUsersPDN ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/user')
        .then((response) => {
          commit('SET_USERS_PDN', response.data.users)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchEmployees ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/employee')
        .then((response) => {
          commit('SET_EMPLOYEES', response.data.employees)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  showOneEmployee ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/employee/${  item.employee_id}`)
        .then((response) => {
          commit('SET_EMPLOYEE', response.data.employee)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addEmployee ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/employee', item)
        .then((response) => {
          commit('ADD_EMPLOYEE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeEmployee ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/user/${itemId}`)
        .then((response) => {
          commit('REMOVE_EMPLOYEE', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateEmployee ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/employee/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_EMPLOYEE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateEmployeePassword ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put('/user/change-password', item)
        .then((response) => {
          commit('UPDATE_EMPLOYEE_PASSWORD')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateEmployeeFlagLogin ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put('/user/flag-login', item)
        .then((response) => {
          commit('UPDATE_EMPLOYEE_FLAG_LOGIN')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //Cambiar ROL del empleado
  updateRoleEmployee ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/employee/${item.id}/change-role`, item)
        .then((response) => {
          commit('UPDATE_EMPLOYEE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                           /////////////////////////////////////////////////
  //////////////////////////////////////          R O L E S           ////////////////////////////////////////////////
  ///////////////////////////////////////                              ////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchRoles ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/role')
        .then((response) => {
          commit('SET_ROLES', response.data.roles)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateRole ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put('/user/change-role', item)
        .then((response) => {
          commit('UPDATE_ROLES', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                           /////////////////////////////////////////////////
  //////////////////////////////////////   D E P A R T A M E N T O S   ////////////////////////////////////////////////
  ///////////////////////////////////////                              ////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchDepartments ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/department')
        .then((response) => {
          commit('SET_DEPARTMENTS', response.data.departments)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                         ///////////////////////////////////
  //////////////////////////////////////   S E D E S  /  H E A D Q U A R T E R S    ///////////////////////////////////
  ///////////////////////////////////////                                           ///////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchHeadquarters ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/headquarter')
        .then((response) => {
          commit('SET_HEADQUARTERS', response.data.headquarters)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     B U S I N E S S    T Y P E S        ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  fetchBusinessTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/business-type')
        .then((response) => {
          commit('SET_BUSINESS_TYPE', response.data.businessTypes)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemBusinessType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/business-type', item)
        .then((response) => {
          commit('ADD_BUSINESS_TYPE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBusinessType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/business-type/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_BUSINESS_TYPE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemBusinessType ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/business-type/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_BUSINESS_TYPE', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     B U S I N E S S    S E C T O R      ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchBusinessSector ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/sector')
        .then((response) => {
          commit('SET_BUSINESS_SECTOR', response.data.sectors)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemBusinessSector ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/sector', item)
        .then((response) => {
          commit('ADD_BUSINESS_SECTOR', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBusinessSector ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/sector/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_BUSINESS_SECTOR', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemBusinessSector ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/sector/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_BUSINESS_SECTOR', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     C L I E N T E S    P D N            ////////////////////////////////////////
  ////////////////////////////////////   (vista Clientes PDN: sólo Admin)      ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchClientsPDN ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/client')
        .then((response) => {
          commit('SET_CLIENTS_PDN_FROM_ADMIN', response.data.clients)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClientsAddedServices ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/added-service')
        .then((response) => {
          commit('SET_CLIENTS_ADDED_SERVICES', response.data.addedServices)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClientsInmigration ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/added-service', {
        params: {
          service_type: 'Inmigration'
        }
      })
        .then((response) => {
          commit('SET_CLIENTS_INMIGRATION', response.data.addedServices)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fecthCustomerAddedServicesInmigration ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/client/${item.client_id}/added-service`, {
        params: {
          service_type: 'Inmigration',
          flag_active_plan: 1
        }
      })
        .then((response) => {
          commit('SET_CLIENTS_ADDED_SERVICES_INMIGRATION', response.data.addedServices)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemClientPDN ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/client', item)
        .then((response) => {
          commit('ADD_CLIENT_PDN_FROM_ADMIN', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateClientPDN ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${item.id_client}`, item)
        .then((response) => {
          commit('UPDATE_CLIENT_PDN_FROM_ADMIN', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////// CHANGE PLAN SERVICE CLIENT /////////////
  updateClientPlan ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${item.id}/change-plan`, item)
        .then((response) => {
          commit('UPDATE_CLIENT_PDN_FROM_ADMIN', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateClientPlanInmigration ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/client/${item.get('id')}/change-inmigration`, item)
        .then((response) => {
          commit('UPDATE_CLIENT_SERVICE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  fetchArrivalDate ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get(`/client/${id_client}/arrival-date`)
        .then((response) => {
          commit('SET_ARRIVAL_DATE', response.data.arrivalDate)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateArrivalDate ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${item.id_client}/arrival-date`, item)
        .then((response) => {
          commit('UPDATE_ARRIVAL_DATE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addContractFile ({ commit}, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/added-service/${item.get('id_added_service')}/add-contract`, item)
        .then((response) => {
          commit('ADD_CONTRACT_FILE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteContractFileInmigration ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete(`/added-service/${item.id_added_service}/remove-contract`, item)
        .then((response) => {
          commit('REMOVE_CONTRACT_FILE_INMIGRATION')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removePlanVP ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${id_client}/remove-plan`)
        .then((response) => {
          commit('REMOVE_PLAN_VP')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeInmigrationService ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${item.id}/remove-inmigration`, item)
        .then((response) => {
          commit('REMOVE_INMIGRATION_SERVICE')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateClientPlanFromPerfilCliente ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${item.id}/change-plan`, item)
        .then((response) => {
          commit('UPDATE_CLIENT_PDN_FROM_PERFIL_CLIENTE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////     C H A N G E   P A S S W O R D      /////////////////////////s 
  updatePasswordClientPDN ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put('/user/change-password', item)
        .then((response) => {
          commit('UPDATE_PASSWORD_CLIENT_PDN_FROM_ADMIN', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  //////////////////      C O U N T R I E S     ////////////////// 

  fetchCountries ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/country')
        .then((response) => {
          commit('SET_COUNTRIES', response.data.countries)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     P E R F I L    C L I E N T E S      ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchClientPerfil ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/client/${item.id_client}`)
        .then((response) => {
          commit('SET_CLIENT_INFO_FOR_PERFIL', response.data.client)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateClientPerfil ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client/${item.id_client}`, item)
        .then((response) => {
          commit('UPDATE_CLIENT_INFO_FOR_PERFIL', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClientTimeline ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/client/${item.id_client}/timeline`)
        .then((response) => {
          commit('SET_CLIENT_TIMELINE', response.data.clientTimelines)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////           PAGOS / PAYMENTS              ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchPayments ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/payment')
        .then((response) => {
          commit('SET_PAYMENTS', response.data.payments)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  //Esto es para la vista de 'Mis Pagos' para los clientes
  fetchMyPayments ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/payment/my-payments')
        .then((response) => {
          commit('SET_PAYMENTS', response.data.payments)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPaymentsForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/payment', {
        params: {
          client_id: item.id_client
        }
      })
        .then((response) => {
          commit('SET_PAYMENTS_FOR_A_CLIENT', response.data.payments)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchPaymentsForAClientNoneService ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get('payment/payments-without-associated-service', {
        params: {
          client_id: obj.id_client
        }
      })
        .then((response) => {
          commit('SET_PAYMENTS_FOR_A_CLIENT_NONE_SERVICE', response.data.paymentsWithoutAssociatedService)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemPayment ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/payment', item)
        .then((response) => {
          commit('ADD_PAYMENT', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemPayment ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/payment/${item.id_payment}`, item)
        .then((response) => {
          commit('UPDATE_PAYMENT', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemPaymentFile ({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`/payment/${formData.get('id_payment')}/file`, formData)
        .then((response) => {
          commit('UPDATE_PAYMENT_FORMDATA', formData)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemPaymentForAClient ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/payment/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_PAYMENT_FOR_A_CLIENT', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateApprovalPayment ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/payment/${item.id_payment}/approve`, item)
        .then((response) => {
          commit('UPDATE_APPROVAL_PAYMENT')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////     P E R F I L    E M P L E A D O      ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchEmployeePerfil ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/employee/${  item.employee_id}`)
        .then((response) => {
          commit('SET_EMPLOYEE_INFO_FOR_PERFIL', response.data.employee)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateEmployeePerfil ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/employee/${  item.id}`, item)
        .then((response) => {
          commit('UPDATE_EMPLOYEE_INFO_FOR_PERFIL', response.data.employee)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateEmployeeAvatar ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/user/change-my-profile-image', item)
        .then((response) => {
          commit('UPDATE_EMPLOYEE_AVATAR')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  resendEmailVerification ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/client/resend-email-verification', item)
        .then((response) => {
          commit('RESEND_EMAIL_VERIFICATION')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateUsername ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put('/user/change-my-username', item)
        .then((response) => {
          commit('UPDATE_USERNAME')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateUserPassword ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put('/user/change-my-password', item)
        .then((response) => {
          commit('UPDATE_USER_PASSWORD')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateMyProfileImage ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/user/change-my-profile-image', item)
        .then((response) => {
          commit('UPDATE_MY_PROFILE_IMAGE')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////              C I U D A D E S            ////////////////////////////////////////
  ////////////////////////////////////             P R O V I N C I A S         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  fetchProvinces ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/province')
        .then((response) => {
          commit('SET_PROVINCES', response.data.provinces)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchMunicipalities ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/municipality')
        .then((response) => {
          commit('SET_MUNICIPALITIES', response.data.municipalities)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDistricts ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/district')
        .then((response) => {
          commit('SET_DISTRICTS', response.data.districts)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCities ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/city')
        .then((response) => {
          commit('SET_CITIES', response.data.cities)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemDistrict ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/district', item)
        .then((response) => {
          commit('ADD_DISTRICT', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemMunicipality ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/municipality', item)
        .then((response) => {
          commit('ADD_MUNICIPALITY', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateDistrict ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/district/${  item.id}`, item)
        .then((response) => {
          commit('UPDATE_DISTRICT', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateMunicipality ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/municipality/${  item.id}`, item)
        .then((response) => {
          commit('UPDATE_MUNICIPALITY', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemDistrict ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/district/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_DISTRICT', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemMunicipality ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/municipality/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_MUNICIPALITY', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchNeighborhoods ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/neighborhood')
        .then((response) => {
          commit('SET_NEIGHBORHOODS', response.data.neighborhoods)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemNeighborhood ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/neighborhood', item)
        .then((response) => {
          commit('ADD_NEIGHBORHOOD', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateNeighborhood ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/neighborhood/${  item.id}`, item)
        .then((response) => {
          commit('UPDATE_NEIGHBORHOOD', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemNeighborhood ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/neighborhood/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_NEIGHBORHOOD', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  showItemDistrict ({ commit }, itemID) {
    return new Promise((resolve, reject) => {
      axios.get(`/district/${  itemID}`)
        .then((response) => {
          commit('SET_ITEM_DISTRICT', response.data.district)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  showItemNeighborhood ({ commit }, itemID) {
    return new Promise((resolve, reject) => {
      axios.get(`/neighborhood/${  itemID}`)
        .then((response) => {
          commit('SET_ITEM_NEIGHBORHOOD', response.data.neighborhood)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////            N E G O C I O S              ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchBusinesses ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/business')
        .then((response) => {
          commit('SET_BUSINESSES', response.data.businesses)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchBusinessItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/business/${item.business_id}`, item)
        .then((response) => {
          commit('SET_BUSINESS_INFO_FOR_EDIT', response.data.business)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchBusinessTimeline ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/business-timeline', {
        params: {
          business_id: item.business_id
        }
      })
        .then((response) => {
          commit('SET_BUSINESS_TIMELINE', response.data.businessTimelines)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateBusiness ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/business/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_BUSINESS', response.data.business)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addBusiness ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/business', item)
        .then((response) => {
          commit('ADD_BUSINESS', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeBusiness ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/business/${itemId}`)
        .then((response) => {
          commit('REMOVE_BUSINESS', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemBusiness ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/business-multimedia/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_BUSINESS', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////        MENSAJES DE CONTACTO             ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchContactMessages ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/contact')
        .then((response) => {
          commit('SET_CONTACT_MESSAGES', response.data.contacts)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateContact ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/contact/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_CONTACT_MESSAGE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemContactMessage ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/contact/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM_CONTACT_MESSAGE', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////              DOCUMENTOS                 ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchDocuments ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/document')
        .then((response) => {
          commit('SET_DOCUMENTS', response.data.documents)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  ////////////////////////////////////      SOLICITUDES DE CLIETNES            ////////////////////////////////////////
  ////////////////////////////////////                                         ////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchClientRequests ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/client-request')
        .then((response) => {
          commit('SET_CLIENT_REQUESTS', response.data.clientRequests)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClientRequestsOneClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/client-request', {
        params: {
          client_id: item.id_client
        }
      })
        .then((response) => {
          commit('SET_CLIENT_REQUESTS_FOR_A_CLIENT', response.data.clientRequests)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchMyRequests ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/client-request/my-request')
        .then((response) => {
          commit('SET_MY_REQUESTS', response.data.clientRequests)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateClientRequest ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client-request/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_CLIENT_REQUEST', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateClientRequestPerfil ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/client-request/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_CLIENT_REQUEST_PERFIL', item)
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },
  addClientRequest ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/client-request', item)
        .then((response) => {
          commit('ADD_CLIENT_REQUEST', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                      //////////////////////////////////////////////////////
  ////////////////////////////////////////    N O T I F I C A T I O N S  //////////////////////////////////////////////
  ///////////////////////////////////////                        //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchNotifications ({ commit }) {
    return new Promise((resolve, reject) => {
      // axios.get(`/employee/${item}/notification`, item)
      axios.get('/notification')
        .then((response) => {
          commit('SET_NOTIFICATIONS', response.data.notifications)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateNotifications ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/notification/${item.id_notification}/change-flag-read`, item)
        .then((response) => {
          commit('UPDATE_NOTIFICATIONS', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////  A S I G N A C I O N  -  A S E S O R E S  //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchAssignedAdvisors ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/assigned-advisor')
        .then((response) => {
          commit('SET_ASSIGNED_ADVISORS', response.data.assignedAdvisors)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemAssignedAdvisor ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/assigned-advisor/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ASSIGNED_ADVISORS', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAssignedClients ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/employee/${item.employee_id}/assigned-advisor`)
        .then((response) => {
          commit('SET_ASSIGNED_CLIENTS', response.data.assignedAdvisors)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchMyAdvisor ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/client/${item.client_id}/assigned-advisor`)
        .then((response) => {
          commit('SET_MY_ADVISOR', response.data.assignedAdvisor)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       TIPOS DE VIDEOLLAMADA               //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchVideoCallTypesAdmin ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/video-call-type')
        .then((response) => {
          commit('SET_VIDEOCALLTYPES_ADMIN', response.data.videoCallTypes)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addVideoCallTypesAdmin ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/video-call-type', item)
        .then((response) => {
          commit('ADD_VIDEOCALLTYPES_ADMIN', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateVideoCallTypesAdmin ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/video-call-type/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_VIDEOCALLTYPES_ADMIN', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeVideoCallTypesAdmin ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/video-call-type/${itemId}`)
        .then((response) => {
          commit('REMOVE_VIDEOCALLTYPES_ADMIN', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VIDEOLLAMADAS                       //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchVideoCalls ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/video-call')
        .then((response) => {
          commit('SET_VIDEOCALLS', response.data.videoCalls)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchVideoCallsPerAdvisor ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/video-call', {
        params: {
          id_employee: item.employee_id   
        }
      })
        .then((response) => {
          commit('SET_VIDEOCALLS_PER_ADVISOR', response.data.videoCalls)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchVideoCallsPerClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/video-call', {
        params: {
          client_id: item.id_client   
        }
      })
        .then((response) => {
          commit('SET_VIDEOCALLS_PER_CLIENT', response.data.videoCalls)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addVideoCall ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/video-call', item)
        .then((response) => {
          commit('ADD_VIDEOCALL', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateVideoCallByAdvisor ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/video-call/${item.id}/change-status-report`, item)
        .then((response) => {
          commit('UPDATE_VIDEOCALL_BY_ADVISOR', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  resetVideoCall ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.put(`/video-call/${itemId}/restart-status-report`)
        .then((response) => {
          commit('RESET_VIDEOCALLS', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       SERVICES / SERVICIOS                //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchServices ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/service')
        .then((response) => {
          commit('SET_SERVICES', response.data.services)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateServices ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/service/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_SERVICE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemService ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/service', item)
        .then((response) => {
          commit('ADD_SERVICE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFinancialAnalysisForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/financial-analysis/client/${item.id_client}`)
        .then((response) => {
          commit('SET_FINANCIAL_ANALYSIS_FOR_A_CLIENT', response.data.financialAnalyses)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  addOneFinancialAnalysisForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/financial-analysis/${item.id_financial_analysis}/add-one`)
        .then((response) => {
          // commit('SET_FINANCIAL_ANALYSIS_FOR_A_CLIENT', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemFinancialAnalysis ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/financial-analysis/${itemId}`)
        .then((response) => {
          commit('REMOVE_FINANCIAL_ANALYSIS', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemFinancialAnalysis ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/financial-analysis', item)
        .then((response) => {
          commit('ADD_FINANCIAL_ANALYSIS', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAddedServicesForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/added-service', {
        params: {
          client_id: item.id_client
        }
      })
        .then((response) => {
          commit('SET_ADDED_SERVICES_FOR_A_CLIENT', response.data.addedServices)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateFlagPaymentCompleted ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/added-service/${item.id_added_service}/update-payment-completed`, item)
        .then((response) => {
          // commit('UPDATE_ADDED_SERVICE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  updatePaymentToService ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/added-service/${item.id_added_service}/add-payment`, item)
        .then((response) => {
          // commit('UPDATE_ADDED_SERVICE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  fetchMyFinancialAnalysisForClients ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/client/financial-analysis-summary')
        .then((response) => {
          commit('SET_FINANCIAL_ANALYSIS_SUMMARY', response.data.financialAnalyses)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       USER TYPE COMMENT                   //////////////////////////////////
  ///////////////////////////////////////                                            //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchUserCommentType ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/user-comment-type')
        .then((response) => {
          commit('SET_USER_COMMENT_TYPES', response.data.userCommentTypes)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemUserCommentType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/user-comment-type', item)
        .then((response) => {
          commit('ADD_USER_COMMENT_TYPE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemUserCommentType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/user-comment-type/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_USER_COMMENT_TYPE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemUserCommentType ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/user-comment-type/${itemId}`)
        .then((response) => {
          commit('REMOVE_USER_COMMENT_TYPE', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       USER COMMENTS                       //////////////////////////////////
  ///////////////////////////////////////         para mostrar en Perfil Interno     //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchUserCommentsForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/user-comment', {
        params: {
          client_id: item.id_client
        }
      })
        .then((response) => {
          commit('SET_USER_COMMENTS_FOR_A_CLIENT', response.data.userComments)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUserCommentsFiltered ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/user-comment', {
        params: {
          client_id: item.id_client,
          user_comment_type_id: item.user_comment_type_id
        }
      })
        .then((response) => {
          commit('SET_USER_COMMENTS_FOR_A_CLIENT', response.data.userComments)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  fetchUserComments ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get('/user-comment')
        .then((response) => {
          commit('SET_USER_COMMENTS', response.data.userComments)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemUserComment ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/user-comment', item)
        .then((response) => {
          commit('ADD_USER_COMMENT', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemUserComment ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/user-comment/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_USER_COMMENT', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemUserComment ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/user-comment/${itemId}`)
        .then((response) => {
          commit('REMOVE_USER_COMMENT', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA TYPES                           //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchVisaTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/visa-type')
        .then((response) => {
          commit('SET_VISA_TYPES', response.data.visaTypes)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemVisaTypeForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`client/${item.id_client}/visa-type`, item)
        .then((response) => {
          commit('UPDATE_ITEM_VISA_TYPE_FOR_A_CLIENT', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemVisaType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-type/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_VISA_TYPE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemVisaType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/visa-type', item)
        .then((response) => {
          commit('ADD_ITEM_VISA_TYPE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchClientAddedServicesInmigration ({ commit }, client_id) {
    return new Promise((resolve, reject) => {
      axios.get('/added-service', {
        params: {
          client_id,
          service_type: 'Inmigration'
        }
      })
        .then((response) => {
          commit('SET_CLIENTS_ADDED_SERVICES_INMIGRATION', response.data.addedServices)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       FAMILY                              //////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchClientFamily ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get('/family', {
        params: {
          client_id: id_client
        }
      })
        .then((response) => {
          commit('SET_CLIENT_FAMILY', response.data.families)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchFamilyTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/family-type')
        .then((response) => {
          commit('SET_FAMILY_TYPES', response.data.familyTypes)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  addFamily ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/family', item)
        .then((response) => {
          commit('ADD_FAMILY', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateFamily ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/family/${item.id_family}`, item)
        .then((response) => {
          commit('UPDATE_FAMILY', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeFamily ({ commit }, id_family) {
    return new Promise((resolve, reject) => {
      axios.delete(`/family/${id_family}`)
        .then((response) => {
          commit('REMOVE_FAMILY', id_family)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA DOCUMENT                           //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchVisaDocumentTypes ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/visa-document-type')
        .then((response) => {
          commit('SET_VISA_DOCUMENT_TYPES', response.data.visaDocumentTypes)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemVisaDocumentType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-document-type/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_VISA_DOCUMENT_TYPE', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemVisaDocumentType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/visa-document-type', item)
        .then((response) => {
          commit('ADD_ITEM_VISA_DOCUMENT_TYPE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemVisaDocumentType ({ commit }, id_visa_document_type) {
    return new Promise((resolve, reject) => {
      axios.delete(`/visa-document-type/${id_visa_document_type}`)
        .then((response) => {
          commit('REMOVE_ITEM_VISA_DOCUMENT_TYPE')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA REQUIREMENT                       //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchVisaRequirementsForAClient ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get('/visa-requirement', {
        params: {
          client_id: id_client
        }
      })
        .then((response) => {
          commit('SET_VISA_REQUIREMENTS_FOR_A_CLIENT', response.data.visaRequirements)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchAddedServicesForAClientInmigration ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get(`/client/${id_client}/added-service`, {
        params: {
          service_type: 'Inmigration', 
          flag_active_plan: 1
        }
      })
        .then((response) => {
          commit('SET_ADDED_SERVICE_FOR_A_CLIENT_INMIGRATION', response.data.addedServices)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  addItemVisaRequirementForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/visa-requirement', item)
        .then((response) => {
          commit('ADD_ITEM_VISA_REQUIREMENT_FOR_A_CLIENT', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateStatusVisaRequirement ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-requirement/${item.id_visa_requirement}/update-status`, item)
        .then((response) => {
          commit('UPDATE_STATUS_ITEM_VISA_REQUIREMENT')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  uploadFileVisaRequirement ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/visa-requirement/${item.get('id_visa_requirement')}/add-file`, item)
        .then((response) => {
          commit('UPLOAD_FILE_VISA_REQUIREMENT')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteFileVisaRequirement ({ commit }, id_visa_requirement) {
    return new Promise((resolve, reject) => {
      axios.delete(`/visa-requirement/${id_visa_requirement}/remove-file`)
        .then((response) => {
          commit('REMOVE_FILE_VISA_REQUIREMENT')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteVisaRequirement ({ commit }, id_visa_requirement) {
    return new Promise((resolve, reject) => {
      axios.delete(`/visa-requirement/${id_visa_requirement}`)
        .then((response) => {
          commit('REMOVE_VISA_REQUIREMENT')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemVisaRequirement ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-requirement/${item.visa_requirement_id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_VISA_REQUIREMENT')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemMetadataVisaRequirement ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-requirement/${item.visa_requirement_id}/update-metadata`, item)
        .then((response) => {
          commit('UPDATE_ITEM_METADATA_VISA_REQUIREMENT')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA STEPS                          //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchVisaStepsForAClient ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get('/visa-step', {
        params: {
          client_id: id_client
        }
      })
        .then((response) => {
          commit('SET_VISA_STEPS_FOR_A_CLIENT', response.data.visaSteps)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemVisaStepForAClient ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/visa-step', item)
        .then((response) => {
          commit('ADD_ITEM_VISA_STEP_TYPE_FOR_A_CLIENT', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemDataVisaStep ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-step/${item.id_visa_step}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_DATA_VISA_STEP')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  updateItemStatusVisaStep ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-step/${item.id_visa_step}/update-status`, item)
        .then((response) => {
          commit('UPDATE_STATUS_ITEM_VISA_STEP')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteItemVisaStep ({ commit }, id_visa_step) {
    return new Promise((resolve, reject) => {
      axios.delete(`/visa-step/${id_visa_step}`)
        .then((response) => {
          commit('DELETE_ITEM_VISA_STEP')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       VISA STEPS TYPES                    //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchVisaStepType ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get('/visa-step-type')
        .then((response) => {
          commit('SET_VISA_STEP_TYPES', response.data.visaStepTypes)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItemVisaStepType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/visa-step-type', item)
        .then((response) => {
          commit('ADD_ITEM_VISA_STEP_TYPE', Object.assign(item, { id: response.data.id }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItemVisaStepType ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/visa-step-type/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_ITEM_VISA_STEP_TYPE')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  deleteItemVisaStepType ({ commit }, id_visa_step_type) {
    return new Promise((resolve, reject) => {
      axios.delete(`/visa-step-type/${id_visa_step_type}`)
        .then((response) => {
          commit('DELETE_ITEM_VISA_STEP_TYPE')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       STATISTICS                    //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchTotalClientsByPlan ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get('statistics/total-clients-by-plan')
        .then((response) => {
          commit('SET_TOTAL_CLIENTS_BY_PLAN', response.data.statistics)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  fetchInmigrationClients ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get('added-service', {
        params: {
          service_type: 'Inmigration'
          // flag_active_plan: 1
        }
      })
        .then((response) => {
          commit('SET_INMIGRATONS_CLIENTS', response.data.addedServices)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       CALENDAR                    //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  addEvent ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('/calendar', obj)
        .then((response) => {
          commit('ADD_EVENT', Object.assign(obj, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchEvents ({ commit }, id_client) {
    return new Promise((resolve, reject) => {
      axios.get('calendar', {
        params: {
          client_id: id_client
        }
      })
        .then((response) => {
          commit('SET_EVENTS', response.data.calendars)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchEventPerAsessor ({ commit }, employee_id) {
    return new Promise((resolve, reject) => {
      axios.get('calendar', {
        params: {
          employee_id
        }
      })
        .then((response) => {
          commit('SET_EVENTS', response.data.calendars)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchEventLabels ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/apps/calendar/labels')
        .then((response) => {
          commit('SET_LABELS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  editEvent ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.put(`calendar/${obj.id}`, obj)
        .then((response) => {
          commit('UPDATE_EVENT', obj)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeEvent ({ commit }, eventId) {
    return new Promise((resolve, reject) => {
      axios.delete(`calendar/${eventId}`)
        .then((response) => {
          commit('REMOVE_EVENT', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  eventDragged ({ commit }, payload) {
    const newEndDate = `${new Date(payload.date.getTime() + (new Date(payload.event.endDate).getTime() - new Date(payload.event.startDate).getTime()))}`
    const obj = { 
      id: payload.event.id, 
      name: payload.event.title,
      description: payload.event.classes[0], 
      start_date: `${new Date(payload.date).getFullYear()}-${new Date(payload.date).getMonth() + 1}-${new Date(payload.date).getDate()}`,
      due_date: `${new Date(newEndDate).getFullYear()}-${new Date(newEndDate).getMonth() + 1}-${new Date(newEndDate).getDate()} 23:59:59`
    }
    if (payload.event.id_client) obj.client_id = payload.event.id_client
    return new Promise((resolve, reject) => {
      axios.put(`calendar/${obj.id}`, obj)
        .then((response) => {
          commit('UPDATE_EVENT', obj)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  sendWelcomeEmail ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`/client/${obj.id_client}/welcome`, obj)
        .then((response) => {
          commit('SEND_WELCOME_EMAIL')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////                                          //////////////////////////////////
  ////////////////////////////////////////       MONDAY LINKS                            //////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  fetchMondayLinks ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get(`/client/${obj.id_client}/monday-data`)
        .then((response) => {
          commit('SET_MONDAY_LINKS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  editMondayLinks ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post(`/client/${obj.id_client}/monday-data`, obj)
        .then((response) => {
          commit('EDIT_MONDAY_LINK', Object.assign(obj, {id: response.data.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }

}

export default actions
